export const FETCH_ALL_CONSOLIDATED_PRODUCT_DETAIL_REQUEST = 'FETCH_ALL_CONSOLIDATED_PRODUCT_DETAIL_REQUEST'
export const FETCH_ALL_CONSOLIDATED_PRODUCT_DETAIL_SUCCESS = 'FETCH_ALL_CONSOLIDATED_PRODUCT_DETAIL_SUCCESS'
export const FETCH_ALL_CONSOLIDATED_PRODUCT_DETAIL_FAILED = 'FETCH_ALL_CONSOLIDATED_PRODUCT_DETAIL_FAILED'
export const FETCH_ALL_CONSOLIDATED_PRODUCTS_REQUEST = 'FETCH_ALL_CONSOLIDATED_PRODUCTS_REQUEST'
export const FETCH_ALL_CONSOLIDATED_PRODUCTS_SUCCESS = 'FETCH_ALL_CONSOLIDATED_PRODUCTS_SUCCESS'
export const FETCH_ALL_CONSOLIDATED_PRODUCTS_FAILED = 'FETCH_ALL_CONSOLIDATED_PRODUCTS_FAILED'
